import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import logoFull from '../../assets/brand/logo-full-trimmed.png';

const AdminLoginPage = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            const base = process.env.REACT_APP_API_URL || 'http://localhost:8001/api/';
            const res = await axios.post(`${base}admin/login`, { email, password });
            localStorage.setItem('admin_access_token', res.data.access);
            navigate('/admin/dashboard');
        } catch (err) {
            setError(err.response?.data?.error || 'ログインに失敗しました');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ minHeight: '100vh', background: '#f5f6f8', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div style={{ background: '#fff', borderRadius: 10, padding: '40px 36px', width: 360, boxShadow: '0 4px 20px rgba(0,0,0,0.08)' }}>
                <div style={{ textAlign: 'center', marginBottom: 28 }}>
                    <img src={logoFull} alt="のりいれ三丁目" style={{ height: 32, display: 'block', margin: '0 auto 6px' }} />
                    <p style={{ fontSize: '0.83rem', color: '#6b7280', margin: 0 }}>管理者ログイン</p>
                </div>

                {error && (
                    <div style={{ background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 6, padding: '10px 14px', marginBottom: 18, fontSize: '0.83rem', color: '#dc2626' }}>
                        {error}
                    </div>
                )}

                <form onSubmit={handleSubmit}>
                    <div style={{ marginBottom: 16 }}>
                        <label style={{ display: 'block', fontSize: '0.82rem', fontWeight: 500, color: '#374151', marginBottom: 6 }}>メールアドレス</label>
                        <input
                            type="email"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                            required
                            style={{ width: '100%', padding: '9px 12px', border: '1px solid #e0e4ea', borderRadius: 6, fontSize: '0.875rem', outline: 'none', boxSizing: 'border-box' }}
                        />
                    </div>
                    <div style={{ marginBottom: 24 }}>
                        <label style={{ display: 'block', fontSize: '0.82rem', fontWeight: 500, color: '#374151', marginBottom: 6 }}>パスワード</label>
                        <input
                            type="password"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            required
                            style={{ width: '100%', padding: '9px 12px', border: '1px solid #e0e4ea', borderRadius: 6, fontSize: '0.875rem', outline: 'none', boxSizing: 'border-box' }}
                        />
                    </div>
                    <button
                        type="submit"
                        disabled={loading}
                        style={{ width: '100%', padding: '10px', background: loading ? '#9ca3af' : '#141c3d', color: '#fff', border: 'none', borderRadius: 6, fontSize: '0.9rem', fontWeight: 600, cursor: loading ? 'default' : 'pointer' }}
                    >
                        {loading ? 'ログイン中...' : 'ログイン'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default AdminLoginPage;
